import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces/index';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      marginTop: '20px',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        justifyContent: 'space-between',
      },
    },
    step: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginRight: '40px',
      width: '80px',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        marginRight: '0',
        width: '48px',
      },
      [breakpoints.down(ScreenSizes.Mobile)]: {
        width: '46px',
      },
    },
    circle: (isCurrentStep: boolean) => ({
      width: '50px',
      height: '50px',
      borderRadius: '25px',
      backgroundColor: isCurrentStep ? appTheme?.mainColor : colors.grey,
      color: isCurrentStep ? colors.white : colors.grey_500,
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      position: 'relative',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        width: '48px',
        height: '48px',
      },
      [breakpoints.down(ScreenSizes.Mobile)]: {
        width: '46px',
        height: '46px',
      },
    }),
    stepIcon: {
      height: '18px',
      width: '18px',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        height: '16px',
        width: '16px',
      },
      [breakpoints.down(ScreenSizes.Mobile)]: {
        height: '14px',
        width: '14px',
      },
    },
    pastStepCheck: {
      position: 'absolute',
      bottom: '0',
      right: '0',
    },
    stepName: {
      fontSize: '14px',
      textAlign: 'center',
      [breakpoints.down(ScreenSizes.Tablet)]: {
        display: 'none',
      },
    },
  };
};
